import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  FORM_NAME_CHALLENGE_QUESTION,
  FORM_NAME_LOGIN_FORM,
  FORM_NAME_ONE_TIME_PASSCODE,
} from '../Helpers/LoginHelper.js'
import NewUser from '../Static/NewUser.jsx'

function ChallengeChoice({
  handleDisplayChange,
  mfaResponseData,
  showNewUser = true,
  showForgotPasswordLink = true,
}) {
  const CHOICE_CHALLENGE_REQUEST_PASSCODE = 'challenge-request-passcode'
  const CHOICE_CHALLENGE_ANSWER_QUESTION = 'challenge-answer-question'

  const [choice, setChoice] = useState('challenge-request-passcode')

  const challengeQuestionRoute = 'KBA'

  //such sadness, this code accounts for both scenarios from FYP and login challenge :(
  const _oneTimePasscodeId =
    mfaResponseData &&
    mfaResponseData.value &&
    mfaResponseData.value.routes &&
    ((mfaResponseData.value.routes.value &&
      mfaResponseData.value.routes.value.find((route) => {
        return route.channel === 'Email'
      })) ||
      mfaResponseData.value.routes.find((route) => {
        return route.channel === 'Email'
      }))

  const oneTimePasscodeId = _oneTimePasscodeId && _oneTimePasscodeId.id

  const challengeQuestionId = challengeQuestionRoute

  const onChoiceChange = (event) => {
    setChoice(event.target.value)
  }

  const onSubmitClicked = () => {
    const form =
      choice === CHOICE_CHALLENGE_REQUEST_PASSCODE
        ? FORM_NAME_ONE_TIME_PASSCODE
        : FORM_NAME_CHALLENGE_QUESTION
    const id =
      choice === CHOICE_CHALLENGE_REQUEST_PASSCODE
        ? oneTimePasscodeId
        : challengeQuestionId

    handleDisplayChange(form, id)
  }

  const onCancelledClicked = () => {
    handleDisplayChange(FORM_NAME_LOGIN_FORM)
  }

  const showChallengeQuestion =
    mfaResponseData &&
    mfaResponseData.value &&
    (mfaResponseData.value.kba === true || mfaResponseData.value.kba === 'true')
  const showOneTimePassCode = !!_oneTimePasscodeId

  return (
    <div
      className="u-bgColorLightest u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft0 u-borderRight0 u-padding8gu u-marginBottom10gu"
      data-analytics-login-step="Verify Identity"
    >
      <div className="Grid">
        <div className="u-sizeFull u-lg-size5of12 u-lg-after1of12 u-marginBottom6gu u-lg-marginBottom0 Content">
          <h2 className="u-marginTop0 u-marginBottom1gu">
            We need to verify your identity
          </h2>
          <p className="u-marginBottom2gu">
            Help us keep your account more secure.
          </p>
          <fieldset>
            <legend className="u-marginBottom4gu">Choose one option:</legend>
            <div className="Radio u-paddingLeft2gu u-marginBottom3gu">
              {showOneTimePassCode && (
                <>
                  <input
                    onChange={onChoiceChange}
                    className="Radio-button u-marginLeft0"
                    id={CHOICE_CHALLENGE_REQUEST_PASSCODE}
                    type="radio"
                    value={CHOICE_CHALLENGE_REQUEST_PASSCODE}
                    name="challenge-radio"
                    checked={choice === CHOICE_CHALLENGE_REQUEST_PASSCODE}
                    data-analytics-login-option="OTP"
                  />
                  <label
                    htmlFor="challenge-request-passcode"
                    className="Radio-label u-inlineBlock u-textSecondary u-marginBottom2gu u-marginLeft0"
                  >
                    Request a one-time passcode that will be sent to your email
                    address.{' '}
                    <span className="u-block u-paddingTop1gu">
                      <span className="u-textBold">Important:</span> Passcode
                      expires in 30 minutes.
                    </span>
                  </label>
                </>
              )}

              {showChallengeQuestion && (
                <>
                  <input
                    onChange={onChoiceChange}
                    className="Radio-button u-marginLeft0"
                    id={CHOICE_CHALLENGE_ANSWER_QUESTION}
                    type="radio"
                    value={CHOICE_CHALLENGE_ANSWER_QUESTION}
                    name="challenge-radio"
                    checked={choice === CHOICE_CHALLENGE_ANSWER_QUESTION}
                    data-analytics-login-option="Security Question"
                  />
                  <label
                    htmlFor="challenge-answer-question"
                    className="Radio-label u-marginLeft0 u-textSecondary"
                  >
                    Answer a security question you created for this account.
                  </label>
                </>
              )}
            </div>
            <button
              onClick={onSubmitClicked}
              className="Button Button--primary  Button--block u-marginRight5gu u-marginBottom2gu u-textNoTransform"
              data-analytics="login-verify-identity-continue"
            >
              Continue
            </button>
            <button
              onClick={onCancelledClicked}
              className="Button Button--secondary Button--block u-textNoTransform"
              data-analytics="login-verify-identity-cancel"
            >
              Cancel
            </button>
            {showForgotPasswordLink && (
              <a
                href="/register/forgot-password/"
                className="Link u-block"
                data-tracking="Link"
              >
                Forgot Password?
              </a>
            )}
          </fieldset>
        </div>
        {showNewUser && (
          <div className="u-sizeFull u-lg-before1of12 u-lg-size5of12 Content">
            <NewUser />
          </div>
        )}
      </div>
    </div>
  )
}

ChallengeChoice.propTypes = {
  handleDisplayChange: PropTypes.func,
  mfaResponseData: PropTypes.object,
  showNewUser: PropTypes.bool,
  showForgotPasswordLink: PropTypes.bool,
}

export default ChallengeChoice
